var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppOptimizationImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#e7e6e6;}.c{fill:#8c94c9;}.d{fill:#97d3f1;}.e{opacity:0.995;}.f{fill:#007da0;}.g{fill:#0fb4d1;}.h{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.373 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(56.15 88.221)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(47.443 36.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(42.611 64.432)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22 -14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(81.357 79.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(89.932 47.762)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(62.533 16.227)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-123.807 83.324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.266 -623.078)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M189.678,594.633l-2.768-.674c.645-.86,1.221-1.686,1.87-2.449a1.123,1.123,0,0,1,.864-.283,9.258,9.258,0,0,0,7.69-2.328,9.037,9.037,0,0,0,2.811-9.679,8.93,8.93,0,0,0-7.327-6.711,9.135,9.135,0,0,0-9.491,3.8c-.179.234-.339.484-.416.595l-3.061-1.259,1.01-1.691c-.434-.4-.927-.813-1.374-1.271a1.64,1.64,0,0,1-.106-2.393,1.669,1.669,0,0,1,2.457.1c.429.413.838.847,1.264,1.281a25.467,25.467,0,0,1,2.413-1.374,14.171,14.171,0,0,1,2.992-1c.737-.141.967-.409.877-1.1a7.392,7.392,0,0,1-.006-.882c-1.165-.043-2.461.164-2.783-1.365A1.748,1.748,0,0,1,187.723,564H194.4a1.706,1.706,0,0,1,1.171,1.915c-.3,1.611-1.646,1.348-2.846,1.413a10.261,10.261,0,0,0,.019,1.352.671.671,0,0,0,.394.477,13.453,13.453,0,0,1,5.9,2.622c.437-.5.836-1.015,1.3-1.467a1.641,1.641,0,1,1,2.323,2.315c-.449.47-.946.894-1.32,1.243.655,1.363,1.308,2.58,1.825,3.852a20.042,20.042,0,0,1,.685,2.57v2.933a3.44,3.44,0,0,0-.146.45,12.646,12.646,0,0,1-9.459,10.537c-.59.176-1.2.281-1.8.419Z",
    transform: "translate(-35.628 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M142.805,668.294a1.719,1.719,0,0,1-.832-1.485c-.033-.489-.191-.887-.75-1.006a1.086,1.086,0,0,1-.5-.266,1.815,1.815,0,0,0-2.338-.309.8.8,0,0,1-.549.049c-.949-.265-1.209-1.154-1.467-1.908a1.6,1.6,0,0,1,.558-1.28,1.537,1.537,0,0,0,.674-1.645,1.954,1.954,0,0,1,.012-.89,1.029,1.029,0,0,0-.481-1.161,1.951,1.951,0,0,1,.445-3.278,2.258,2.258,0,0,1,1.38.142,1.053,1.053,0,0,0,1.252-.175,1.173,1.173,0,0,1,.475-.306,1.811,1.811,0,0,0,1.387-1.813,1.057,1.057,0,0,1,1.208-.962c.353,0,.706,0,1.058,0a1.105,1.105,0,0,1,1.213,1.063,1.545,1.545,0,0,0,1.179,1.591,1.481,1.481,0,0,1,.618.382,1.088,1.088,0,0,0,1.32.2,1.954,1.954,0,0,1,2.6,2.027,1.871,1.871,0,0,1-.695,1.024,1.237,1.237,0,0,0-.59,1.371,1.093,1.093,0,0,1,.016.485,1.79,1.79,0,0,0,.847,2.059,1.069,1.069,0,0,1,.283,1.519c-.152.287-.328.562-.484.847a1.152,1.152,0,0,1-1.638.59,1.487,1.487,0,0,0-1.905.22,1.226,1.226,0,0,1-.564.314c-.709.163-.812.7-.982,1.3a5.563,5.563,0,0,1-.8,1.31Zm.971-5.826a2.332,2.332,0,1,0-2.307-2.33A2.3,2.3,0,0,0,143.776,662.468Z",
    transform: "translate(0 -73.661)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M240.873,645.659a2.522,2.522,0,0,1,2.307-2.5,2.167,2.167,0,0,0,1.009-.388c.976-.731,1.922-1.5,2.865-2.278.524-.431,1.069-.614,1.584-.07a1.061,1.061,0,0,1-.079,1.535c-.667.82-1.306,1.665-1.99,2.471a3.184,3.184,0,0,0-.777,1.722,2.431,2.431,0,0,1-2.632,2.031A2.51,2.51,0,0,1,240.873,645.659Z",
    transform: "translate(-87.493 -63.687)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppOptimizationImage);
export default __webpack_public_path__ + "static/media/appOptimizationImage.04dd412d68abfdab81a52af40953aeef.svg";
export { ForwardRef as ReactComponent };